import React from "react";

const NoResults = ({ results }) => {
  if (results) {
    if (results.otd.posts === 0 && results.other.length === 0 && results.sleevery.sleeves === 0 && results.totd.found === false && results.interviews.interviews === 0) {
      return <div className="NoResultsWrapper">We couldn't really find anything all that great. Please try again.</div>;
    }
  }

  return null;
};

export default NoResults;
